import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/app/global-error.tsx");
